import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

import "./index.css";
import "./uizard/theme.css";

function boot() {
  const container = document.getElementById("root");
  if (!container) {
    console.error("Root container '#root' not found. Check public/index.html.");
    return;
  }
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
